// Multivariate dependencies
import React, { useMemo } from 'react';
// Component
import { ContainerLegacy } from '../styles/Containers/ContainerLegacy';
/**
 * Content container that displays the active tab
 *
 * @deprecated Do not use legacy components anymore.
 * @param {TabContentProps} props { tabsConfig, activeTabId, divId, recordId }
 * @returns {Element} - tab content
 */
export var TabContent = function (_a) {
    var tabsConfig = _a.tabsConfig, activeTabId = _a.activeTabId, divId = _a.divId, recordId = _a.recordId;
    var activeTab = tabsConfig.find(function (_a) {
        var id = _a.id;
        return activeTabId && id === activeTabId;
    });
    var Component = useMemo(function () { return activeTab === null || activeTab === void 0 ? void 0 : activeTab.content; }, [activeTab.content]);
    if (!activeTabId)
        return null;
    return (React.createElement(ContainerLegacy, { as: 'div', "data-testid": 'tabContent', overflow: 'auto', padding: '5px 15px 5px', backgroundColor: '#ffffff', borderRadius: '0 0 6px 6px', border: '1px solid grey', borderTop: '0' },
        React.createElement(Component, { "data-testid": divId, targetDivId: divId, recordId: recordId })));
};
//# sourceMappingURL=TabContent.js.map